import { Component, Input } from '@angular/core';

export type BadgePosition = 'left' | 'right';

@Component({
  selector: 'app-home-step-card-v2',
  templateUrl: './home-step-card-v2.component.html',
  styleUrl: './home-step-card-v2.component.scss'
})
export class HomeStepCardV2Component {
  @Input() number!: number;
  @Input() title!: string;
  @Input() body!: string;
  @Input() badgePosition: BadgePosition = 'left';
}
